import React from "react";
import "./ShippingPolicy.scss";

const ShippingPolicy = () => {
  return (
    <div>
      <div className="SP-main">
        <div className="SP-outer">
          <div className="SP-part">
            <div className="SP-inner">
              <p>
                At RAER, we strive to provide a seamless and efficient shopping
                experience for our valued customers. Our shipping policy is
                designed to ensure timely delivery and customer satisfaction.
                Please read the following terms carefully before placing an
                order.
              </p>
            </div>
            <div className="SP-inner">
              <h1>Home Delivery</h1>
              <p>
                We offer home delivery services for all orders placed on our
                website. Our dedicated logistics team works tirelessly to
                dispatch your orders promptly and securely.
              </p>
            </div>
            <div className="SP-inner">
              <h1>Delivery Timeframe:</h1>
              <p>
                Orders will be processed and dispatched within 3-5 working days
                from the date of purchase. Once dispatched, the estimated
                delivery time is 3-10 working days, depending on your location.
                Please note that these timeframes are indicative, and actual
                delivery times may vary based on factors such as product
                availability, shipping destination, and unforeseen
                circumstances.
              </p>
            </div>
            <div className="SP-inner">
              <h1>Shipping Charges:</h1>
              <p>
                A shipping fee of Rs.150 will be applied to all orders below
                Rs.3000. Orders with a total value of Rs.3000 or more will
                qualify for free shipping.
              </p>
            </div>
            <div className="SP-inner">
              <h1>Order Tracking:</h1>
              <p>
                Upon dispatch, customers will receive an email confirmation
                containing a tracking number. This tracking number can be used
                to monitor the status and location of your order. Please allow
                24 hours for the tracking information to be updated.
              </p>
            </div>
            <div className="SP-inner">
              <h1>Shipping Locations:</h1>
              <p>
                We currently offer shipping services within India. If your
                location is not covered by our shipping services, we regret that
                we are unable to fulfill your order at this time.
              </p>
            </div>

            <div className="SP-inner">
              <h1>Delivery Address:</h1>
              <p>
                Customers are responsible for providing accurate and complete
                delivery addresses. Any additional charges incurred due to
                incorrect or incomplete addresses will be the customer’s
                responsibility.
              </p>
            </div>
            <div className="SP-inner">
              <h1>Failed Delivery Attempts:</h1>
              <p>
                Our logistics partners will make reasonable attempts to deliver
                the order. In case of failed delivery attempts, the customer
                will be contacted for alternative arrangements. Additional
                charges may apply for re-delivery.
              </p>
            </div>
            <div className="SP-inner">
              <h1>Contact Information:</h1>
              <p>
                If you have any questions or concerns regarding our shipping
                policy, please contact our customer support team at
                raerofficialclothing@gmail.com.
              </p>
              <p>
                RAER reserves the right to update or modify this shipping policy
                at any time without prior notice. Customers are encouraged to
                review the policy periodically for any changes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
